import './viz.css'

export interface HBarRow {
  label: string
  value: number | null
  display: string
}

interface HBarPairProps {
  rows: HBarRow[]
  maxAbs?: number
  ariaLabel: string
}

const hasValue = (value: number | null): value is number =>
  value !== null && Number.isFinite(value)

/** Diverging bars around a centre line: gains extend right, losses left. */
export function HBarPair({ rows, maxAbs, ariaLabel }: HBarPairProps) {
  const derived = Math.max(1, ...rows.map((r) => (hasValue(r.value) ? Math.abs(r.value) : 0)))
  const scale = maxAbs !== undefined && Number.isFinite(maxAbs) && maxAbs > 0 ? maxAbs : derived

  return (
    <div
      className="viz-hbar"
      role="img"
      aria-label={ariaLabel}
      style={{ ['--rows' as string]: Math.max(1, rows.length) }}
    >
      {rows.map((row, i) => {
        const value = hasValue(row.value) ? row.value : null
        const widthPct = value === null ? 0 : Math.min(50, (Math.abs(value) / scale) * 50)
        return (
          <div className="viz-hbar-row" key={`${row.label}-${i}`}>
            <span className="viz-hbar-label">{row.label}</span>
            <span className="viz-hbar-track">
              {value !== null && (
                <span
                  className={`viz-hbar-fill viz-hbar-fill--${value >= 0 ? 'gain' : 'loss'}`}
                  style={{ width: `${widthPct}%` }}
                />
              )}
            </span>
            <span className={`viz-hbar-value${value === null ? ' viz-hbar-value--null' : ''}`}>
              {row.display}
            </span>
          </div>
        )
      })}
    </div>
  )
}
